import { clsx } from 'clsx'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { Photo } from 'type/Options'
import css from './OptionButton.module.scss'

const face_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/profile-options-face-1643.jpg'
const full_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/profile-options-full-f4bf.jpg'
const outfit_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/profile-options-outfit-dd96.jpg'
const tune_jpg = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/profile-options-tune-5af1.jpg'

type Props = {
  photo: Photo
}

function title(photo: Photo) {
  if (photo === 'selfie') return i18n('BySelfie')
  if (photo === 'simple') return i18n('FullBodySelfie')
  if (photo === 'full') return i18n('ByFullBodyPhoto')
}

function desc(photo: Photo) {
  if (photo === 'selfie') return i18n('SelfiesAndBodyAdjustments')
  if (photo === 'simple') return i18n('CombinedProfile')
  if (photo === 'full') return i18n('FullLengthShot')
}

function island(photo: Photo) {
  if (photo === 'selfie') return <Space className={css.island}>
    <Img src={face_jpg} />
    <Typo size={20} medium>+</Typo>
    <Space className={css.tune} top>
      <Img src={tune_jpg} />
    </Space>
    <Typo size={20} medium>=</Typo>
    <Img src={outfit_jpg} />
  </Space>
  if (photo === 'simple') return <Space className={css.island}>
    <Img src={full_jpg} />
    <Typo size={20} medium>+</Typo>
    <Img src={face_jpg} />
    <Typo size={20} medium>=</Typo>
    <Img src={outfit_jpg} />
  </Space>
  if (photo === 'full') return <Space className={css.island}>
    <Img src={full_jpg} />
    <Typo size={20} medium>=</Typo>
    <Img src={outfit_jpg} />
  </Space>
}

export const OptionButton = observer(({ photo }: Props) => {
  const selected = store.createPhoto === photo
  const className = clsx(css.card, selected && css.selected)

  const onClick = useLatestCallback(() => {
    runInAction(() => store.createPhoto = photo)
  })

  return <Space className={className} onClick={onClick}>
    <Space className={css.inner}>
      <Space gap={12}>
        <Vertical gap={16}>
          {island(photo)}
          <Vertical gap={4}>
            <Typo size={14} medium upper>
              {title(photo)}
            </Typo>
            <Typo size={12} secondary>
              {desc(photo)}
            </Typo>
          </Vertical>
        </Vertical>
      </Space>
    </Space>
    <Space className={css.radio}>
      <Space className={css.dot} center>
        {selected && <Icon size={24} name="check_circle" fill />}
      </Space>
    </Space>
  </Space>
})
